import { ApplicationEntityFragment } from "@graffer-inc/smart-apply";
import { ApplicationEntity } from "./application-entity";
import {
  gqlToDomainInvoiceType,
  nullToUndefinedDeep,
} from "@graffer-inc/cloud-gov-core";

export class ApplicationFactory {
  static createFromGql(json: ApplicationEntityFragment) {
    const converted = nullToUndefinedDeep(json);
    return new ApplicationEntity({
      ...converted,
      paymentsV2: converted.paymentsV2?.map((p) => ({
        ...p,
        invoice: {
          ...p.invoice,
          items: p.invoice.items.map((i) => ({
            ...i,
            type: gqlToDomainInvoiceType(i.type),
          })),
        },
      })),
      // deprecated.
      internalComments: [],
      // deprecated.
      messages: [],
    });
  }
}
